const styles = theme => ({
    PrimaryAppBar: {
        // backgroundColor: 'rgba(100,100,100,1)'
        height: '50px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        zIndex: '900',
        opacity: '0.95'
    },
    Appbar: {
        display: 'flex',
        justifyContent: 'center'
    },
    toolbar: {
        display: 'flex',
        justifyContent: 'center'
    },
    centerTool:{
        width: '90%', 
        display: 'flex', 
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    fill: {

    },
    leftToolbar: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center'
    },
    rightToolbar: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    logo: {
        // background: 'linear-gradient(0deg, #240b36 0%, #c31432 99%)',
        background: 'linear-gradient(0deg, #b20a2c, #fffbd5)',
        padding: '5px 20px',
        borderRadius: '10px',
        color: 'white'
    },
    navWide: {
        alignItems: 'center',
        [theme.breakpoints.down('md')]: {
            display: 'none'
        },
        [theme.breakpoints.up('md')]: {
            display: 'flex',
        },
    },
    navDropDown: {
        alignItems: 'flex-end',
        [theme.breakpoints.down('md')]: {
            display: 'flex'
        },
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    menuDropdownVisible: {
        textAlign: 'center',
        position: 'absolute',
        display: 'flex',
        flexDirection: 'column',
        width: '150px',
        zIndex: 1,
        left: '-60px',
        right: '0px',
        top: '40px',
        background: 'rgba(240, 240, 240, 1)',
        [theme.breakpoints.up('md')]: {
            display: 'none'
        }
    },
    menuDropdownInvisible: {
        display: 'none'
    }
})

export default styles;